import { clamp } from "@/utils/math"
import { vec2, vec3 } from "gl-matrix"

export class XYCoord {
	public x = 0.0
	public y = 0.0

	constructor(value: vec2 | XYCoord | undefined = undefined) {
		if (typeof value === "undefined") {
			return
		} else if (value instanceof XYCoord) {
			this.x = value.x
			this.y = value.y
		} else {
			this.x = value[0]
			this.y = value[1]
		}
	}

	public static XYZtoXY(coord: vec3): XYCoord {
		const x = coord[0]
		const y = coord[1]
		const z = coord[2]

		const total = x + y + z

		if (total > 0.0) {
			return new XYCoord([x / total, y / total])
		}

		return XYCoord.D50()
	}

	public static StdA() {
		return new XYCoord([0.4476, 0.4074])
	}

	public static D50() {
		return new XYCoord([0.3457, 0.3585])
	}

	public static D55() {
		return new XYCoord([0.3324, 0.3474])
	}

	public static D65() {
		return new XYCoord([0.3127, 0.329])
	}

	public static D75() {
		return new XYCoord([0.299, 0.3149])
	}

	public static PCStoXY() {
		return XYCoord.D50()
	}

	public static PCStoXYZ() {
		return XYCoord.D50().XYtoXYZ()
	}

	public get isValid() {
		return this.x > 0.0 && this.y > 0.0
	}

	public get isNotValid() {
		return !this.isValid
	}

	public XYtoXYZ(): vec3 {
		const temp = new XYCoord(this)
		temp.x = clamp(temp.x, 0.000001, 0.999999)
		temp.y = clamp(temp.y, 0.000001, 0.999999)

		if (temp.x + temp.y > 0.999999) {
			const scale = 0.999999 / (temp.x + temp.y)
			temp.x *= scale
			temp.y *= scale
		}

		return [temp.x / temp.y, 1.0, (1.0 - temp.x - temp.y) / temp.y]
	}

	public clear() {
		this.x = 0
		this.y = 0
	}
}
